import { SelectValueStyle } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectValue/SelectValueStyle';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components/macro';

export interface ISelectValue {
    label: string;
    value: string;
}

interface Props {
    options: ISelectValue[];
    selectedOption?: ISelectValue;
    onChange?: (value: ISelectValue) => void;
    placeholder?: string;
    maxMenuHeight?: number;
    className?: string;
}

export const SelectValue = (props: Props): JSX.Element => {
    const [selectedOption, setSelectedOption] = useState<ISelectValue>(props.selectedOption);

    useEffect(() => {
        if (!_.isEqual(props.selectedOption, selectedOption)) {
            setSelectedOption(props.selectedOption ?? null);
        }
    }, [props.selectedOption]);

    function update(newValue: ISelectValue) {
        setSelectedOption(newValue);
        props.onChange?.(newValue);
    }

    return (
        <S_SelectValue className={props.className}>
            <Select
                value={selectedOption}
                onChange={update}
                options={props.options}
                styles={SelectValueStyle}
                placeholder={props.placeholder ?? 'Select'}
                components={{
                    ClearIndicator: () => null
                }}
                maxMenuHeight={props.maxMenuHeight ?? null}
            />
        </S_SelectValue>
    );
};

const S_SelectValue = styled.div``;
